import { useMemo } from "react";
import { Box, Button, Stack, Typography, Alert } from "@mui/material";

const WhepDebugPage = () => {
  const debuggerUrl = useMemo(() => {
    const ensureTrailingSlash = (path: string) => (path.endsWith("/") ? path : `${path}/`);
    const fallbackBase = ensureTrailingSlash(import.meta.env.BASE_URL ?? "/");

    if (typeof window === "undefined") {
      return `${fallbackBase}whep-debug.html`;
    }

    const { pathname } = window.location;
    const sentinel = "/debug/whep";
    const idx = pathname.indexOf(sentinel);

    if (idx >= 0) {
      const prefix = pathname.slice(0, idx + 1) || "/";
      return `${ensureTrailingSlash(prefix)}whep-debug.html`;
    }

    return `${fallbackBase}whep-debug.html`;
  }, []);

  return (
    <Stack spacing={1} sx={{ py: 1 }}>
      <Box
        component="iframe"
        src={debuggerUrl}
        sx={{
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: 2,
          minHeight: 980,
          width: "100%",
          backgroundColor: "background.paper"
        }}
        title="SkyView WebRtc Debugger"
      />

        <Alert severity="info">
          The console loads from <code>{debuggerUrl}</code>, resolved for your
          current path. Open it in a new tab for the full-width experience or
          use the embedded view below while keeping the SkyView navigation
          handy.
        </Alert>
        <Stack direction="row" spacing={2}>
          <Button variant="contained" href={debuggerUrl} target="_blank" rel="noreferrer">
            Open in new tab
          </Button>
          <Button variant="outlined" href={debuggerUrl} download>
            Download HTML
          </Button>
        </Stack>
    </Stack>
  );
};

export default WhepDebugPage;
